var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Navbar__user",class:{'Navbar__user--premium': _vm.isPremium}},[(_vm.isNameVisible)?_c('div',[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('UiIcon',{attrs:{"name":_vm.icon,"width":"24","height":"24"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }